import { Component } from 'react';
import autoBind from 'react-autobind';

import AccessControlValidator from '@common/validators/accessControl.validator';

class AccessControl extends Component {
  constructor(props) {
    super(props);
    autoBind(this);
  }

  get validate() {
    const { name, url } = this.props;

    if (name) return AccessControlValidator.checkPermissionsByName(name);
    if (url) return AccessControlValidator.checkPermissionByUrl(url);
    return true;
  }

  render() {
    const { children } = this.props;
    return this.validate ? children : null;
  }
}

export default AccessControl;
